export enum UserRole {
  Administrator = 'Administrator',
  User = 'User',
  Consultant = 'Consultant',
}

export const UserRoles = Object.values(UserRole);

export const UserRolesLookUps = Object.entries(UserRole).map(
  ([value, name]) => ({
    name,
    value,
  })
);
